/**
 * Custom error for subscription limit violations
 */
export class SubscriptionLimitError extends Error {
  public readonly feature: string;
  public readonly currentCount?: number;
  public readonly limit?: number;

  constructor(
    message: string,
    feature: string,
    currentCount?: number,
    limit?: number
  ) {
    super(message);
    this.name = 'SubscriptionLimitError';
    this.feature = feature;
    this.currentCount = currentCount;
    this.limit = limit;

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, SubscriptionLimitError);
    }
  }
}
